module.exports = __webpack_public_path__ + "static/media/homework-card-footer.c4e81d45.png";